/**
 * Carga dinámica de dependencias del SDK de pagos (jQuery + Bootstrap)
 * Aislado para no interferir con Tailwind CSS
 */

let dependenciesLoaded = false;

export const loadPaymentDependencies = () => {
  return new Promise((resolve, reject) => {
    if (dependenciesLoaded) {
      resolve();
      return;
    }

    // Cargar jQuery
    const jqueryScript = document.createElement('script');
    jqueryScript.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
    jqueryScript.integrity = 'sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4=';
    jqueryScript.crossOrigin = 'anonymous';
    
    jqueryScript.onload = () => {
      // Cargar Bootstrap JS
      const bootstrapScript = document.createElement('script');
      bootstrapScript.src = 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/js/bootstrap.bundle.min.js';
      bootstrapScript.integrity = 'sha384-Fy6S3B9q64WdZWQUiU+q4/2Lc9npb8tCaSX9FK7E8HnRr0Jz8D6OP9dO5Vg3Q9ct';
      bootstrapScript.crossOrigin = 'anonymous';
      
      bootstrapScript.onload = () => {
        // Agregar solo estilos críticos de Bootstrap para modales
        const isolationStyles = document.createElement('style');
        isolationStyles.id = 'bootstrap-modal-isolated';
        isolationStyles.textContent = `
          /* Estilos mínimos de Bootstrap solo para modales del SDK */
          .modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}
          .modal{position:fixed;top:0;left:0;z-index:9999;display:none;width:100%;height:100%;overflow:hidden;outline:0}
          .modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}
          .modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translate(0,-50px)}
          .modal.show .modal-dialog{transform:none}
          .modal-dialog-scrollable{display:flex;max-height:calc(100% - 1rem)}
          .modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}
          .modal-dialog-scrollable .modal-body{overflow-y:auto}
          .modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - 1rem)}
          .modal-content{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}
          .modal-backdrop{position:fixed;top:0;left:0;z-index:9998;width:100vw;height:100vh;background-color:#000}
          .modal-backdrop.fade{opacity:0}
          .modal-backdrop.show{opacity:.5}
          .modal-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}
          .modal-header .close{padding:1rem;margin:-1rem -1rem -1rem auto}
          .modal-title{margin-bottom:0;line-height:1.5}
          .modal-body{position:relative;flex:1 1 auto;padding:1rem}
          .modal-footer{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}
          .modal-footer>*{margin:.25rem}
          .modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}
          @media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-sm{max-width:300px}}
          @media (min-width:992px){.modal-lg,.modal-xl{max-width:800px}}
          @media (min-width:1200px){.modal-xl{max-width:1140px}}
          .close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}
          .close:hover{color:#000;text-decoration:none}
          .close:not(:disabled):not(.disabled):hover,.close:not(:disabled):not(.disabled):focus{opacity:.75}
          button.close{padding:0;background-color:transparent;border:0}
          .fade{transition:opacity .15s linear}
          .fade:not(.show){opacity:0}
          .btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}
          .btn:hover{color:#212529;text-decoration:none}
          .btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}
          .btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}
          .btn-secondary{color:#fff;background-color:#6c757d;border-color:#6c757d}
          .btn-secondary:hover{color:#fff;background-color:#5a6268;border-color:#545b62}
          .form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}
          .form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}
          .form-group{margin-bottom:1rem}
        `;
        
        document.head.appendChild(isolationStyles);
        
        dependenciesLoaded = true;
        console.log('✅ Dependencias del SDK cargadas (jQuery + Bootstrap aislado)');
        resolve();
      };
      
      bootstrapScript.onerror = () => reject(new Error('Error al cargar Bootstrap'));
      document.head.appendChild(bootstrapScript);
    };
    
    jqueryScript.onerror = () => reject(new Error('Error al cargar jQuery'));
    document.head.appendChild(jqueryScript);
  });
};
